'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

class Wallet {
  getGamingAccounts() {
    return transport.transport.request("wallet/getGamingAccounts");
  }
  getApplicableBonuses() {
    return transport.transport.request("wallet/getApplicableBonuses");
  }
  forfeitBonus(params) {
    return transport.transport.request("wallet/forfeitBonus", params);
  }
  getDepositRemainingLimits() {
    return transport.transport.request("wallet/getDepositRemainingLimits");
  }
  getTransactionHistory(params) {
    return transport.transport.request("wallet/getTransactionHistoryV2", params);
  }
  getGrantedBonuses() {
    return transport.transport.request("wallet/getGrantedBonuses");
  }
  getGamesTransactions(params) {
    return transport.transport.request("wallet/getGamesTransactions", params);
  }
  getBettingHistoryTotalNetWins(params) {
    return transport.transport.request("wallet/getBettingHistoryTotalNetWins", params);
  }
  getBettingHistory(params) {
    return transport.transport.request("wallet/getBettingHistory", params);
  }
  getBonusesHistory(params) {
    return transport.transport.request("wallet/getBonusesHistory", params);
  }
  getLifetimeDeposits() {
    return transport.transport.request("wallet/getLifetimeDeposits");
  }
}

exports.Wallet = Wallet;
